import { Routes, Route, Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { loginWithTestToken, logout } from './store/slices/authSlice';
import Dashboard from './pages/Dashboard';
import SiteDetail from './pages/SiteDetail';
import Compare from './pages/Compare';
import Admin from './pages/Admin';

function App() {
  const dispatch = useAppDispatch();
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);

  return (
    <div className="app">
      <nav style={{ 
        padding: '1rem', 
        backgroundColor: '#fff', 
        borderBottom: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <div>
          <Link to="/" style={{ marginRight: '1rem' }}>Dashboard</Link>
          <Link to="/compare" style={{ marginRight: '1rem' }}>Compare</Link>
          <Link to="/admin">Admin</Link>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {isAuthenticated ? (
            <>
              <span style={{ fontSize: '0.9rem', color: '#666' }}>
                {user?.name} ({user?.role})
              </span>
              <button
                onClick={() => dispatch(logout())}
                style={{
                  padding: '0.4rem 0.75rem',
                  fontSize: '0.85rem',
                  backgroundColor: '#f3f4f6',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <span style={{ fontSize: '0.85rem', color: '#666' }}>Login as:</span>
              <button
                onClick={() => dispatch(loginWithTestToken('coo'))}
                style={{
                  padding: '0.4rem 0.75rem',
                  fontSize: '0.85rem',
                  backgroundColor: '#dbeafe',
                  border: '1px solid #93c5fd',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                CPSCO
              </button>
              <button
                onClick={() => dispatch(loginWithTestToken('finance'))}
                style={{
                  padding: '0.4rem 0.75rem',
                  fontSize: '0.85rem',
                  backgroundColor: '#dcfce7',
                  border: '1px solid #86efac',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Finance
              </button>
            </>
          )}
        </div>
      </nav>
      <main style={{ padding: '1rem' }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/sites/:siteId" element={<SiteDetail />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
